import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { UserService } from '../../Services/user.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    imports: [RouterModule],
    providers: [],
    styleUrls: ['./toolbar.component.scss']
})

export class ToolbarComponent implements OnInit {

  constructor(private emitterService:EmitterService,
    public UserService:UserService,
    private constantService: ConstantService
  ) {

  }
  setMenu(code: any) {
    this.emitterService.setActiveMenu.emit({ MenuId: 99, MenuName: 'home', SubMenuName: '', exceptionCode: code, page: this.constantService?.getApplicationName() });
  }
/*   passIndexValue(index){
   this.index =index;
 } */

  ngOnInit() {

  }    
}